{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Έχετε υπερβεί το όριο συνομιλιών. Το πρόγραμμα Hacker επιτρέπει μόνο 500 συνομιλίες.",
      "INBOXES": "Έχετε υπερβεί το όριο κιβωτίων εισερχομένων. Το πρόγραμμα Hacker υποστηρίζει μόνο live-chat ιστοσελίδας. Επιπλέον κιβώτια εισερχομένων όπως email, WhatsApp κ.λπ. απαιτούν πληρωμένο πρόγραμμα.",
      "AGENTS": "Έχετε υπερβεί το όριο πρακτόρων. Το πρόγραμμα Hacker επιτρέπει μόνο 2 πράκτορες.",
      "NON_ADMIN": "Παρακαλώ επικοινωνήστε με τον διαχειριστή σας για αναβάθμιση του προγράμματος και να συνεχίσετε να χρησιμοποιείτε όλες τις λειτουργίες."
    },
    "TITLE": "Ρυθμίσεις",
    "SUBMIT": "Ενημέρωση Ρυθμίσεων",
    "BACK": "Πίσω",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Δεν μπορεί να ενημερωθεί η ρύθμιση προσπαθήστε ξανά!",
      "SUCCESS": "Επιτυχής Ενημέρωση Ρυθμίσεων"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Διαγραφή του Λογαριασμού σας",
      "NOTE": "Μόλις διαγράψετε τον λογαριασμό σας, όλα τα δεδομένα σας θα διαγραφούν.",
      "BUTTON_TEXT": "Διαγραφή Λογαριασμού σας",
      "CONFIRM": {
        "TITLE": "Διαγραφή Λογαριασμού",
        "MESSAGE": "Η διαγραφή του λογαριασμού σας είναι μη αναστρέψιμη. Εισάγετε το όνομα του λογαριασμού σας παρακάτω για να επιβεβαιώσετε ότι θέλετε να τον διαγράψετε οριστικά.",
        "BUTTON_TEXT": "Διαγραφή",
        "DISMISS": "Άκυρο",
        "PLACE_HOLDER": "Πληκτρολογήστε {accountName} για επιβεβαίωση"
      },
      "SUCCESS": "Ο λογαριασμός σημειώθηκε για διαγραφή",
      "FAILURE": "Δεν ήταν δυνατή η διαγραφή του λογαριασμού, προσπαθήστε ξανά!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Αυτός ο λογαριασμός είναι προγραμματισμένος για διαγραφή στις {deletionDate}. Αυτό ζητήθηκε από έναν διαχειριστή. Μπορείτε να ακυρώσετε τη διαγραφή πριν από αυτή την ημερομηνία.",
        "MESSAGE_INACTIVITY": "Αυτός ο λογαριασμός είναι προγραμματισμένος για διαγραφή στις {deletionDate} λόγω αδράνειας του λογαριασμού. Μπορείτε να ακυρώσετε τη διαγραφή πριν από αυτή την ημερομηνία.",
        "CLEAR_BUTTON": "Ακύρωση Προγραμματισμένης Διαγραφής"
      }
    },
    "FORM": {
      "ERROR": "Παρακαλώ διορθώστε τα λάθη της Φόρμας",
      "GENERAL_SECTION": {
        "TITLE": "Γενικές Ρυθμίσεις",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID Λογαριασμού",
        "NOTE": "Αυτό το ID απαιτείται αν δημιουργείτε μια ενσωμάτωση βασισμένη στο API"
      },
      "NAME": {
        "LABEL": "Ονομασία Λογαριασμού",
        "PLACEHOLDER": "Η ονομασία του Λογαριασμού σας",
        "ERROR": "Παρακαλώ συμπληρώστε ένα έγκυρο όνομα λογαριασμού"
      },
      "LANGUAGE": {
        "LABEL": "Γλώσσα ιστοσελίδας",
        "PLACEHOLDER": "Το όνομα του Λογαριασμού",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Τομέας (domain) του εισερχόμενου email",
        "PLACEHOLDER": "Ο τομέας στον οποίο θα λαμβάνετε τα emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email Υποστήριξης",
        "PLACEHOLDER": "To email υποστήριξης της εταιρίας σας",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Αριθμός ημερών μετά τις οποίες η συνομιλία θα επιλύεται αυτόματα, αν δεν υπάρχει δραστηριότητα",
        "NOTE": "Αριθμός ωρών αδράνειας μετά τις οποίες κάθε ανοιχτή συνομιλία θα επιλύεται αυτόματα.",
        "PLACEHOLDER": "30",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διάρκεια αυτόματης επίλυσης (ελάχιστο 1 ημέρα και μέγιστο 999 ημέρες)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Αριθμός ημερών μετά τις οποίες μια κενή συνομιλία θα επιλύεται αυτόματα αν δεν υπάρχει δραστηριότητα",
        "PLACEHOLDER": "ποτέ",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διάρκεια αυτόματης επίλυσης κενών συνομιλιών (ελάχιστο 1 ημέρα και μέγιστο 999 ημέρες)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Η συνέχεια της συνομιλίας με emails έχει ενεργοποιηθεί για τον λογαριασμό.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Τώρα μπορείτε να λαμβάνετε emails στον τομέα (domain) σας."
      },
      "PHONE": {
        "TITLE": "Ρυθμίσεις PBX",
        "NOTE": "Ρυθμίστε τη σύνδεση με το PBX σας για τηλεφωνικές κλήσεις",
        "SIP_HOST": {
          "LABEL": "SIP domain"
        },
        "DIALING_MODE": {
          "LABEL": "Λειτουργία κλήσης",
          "MODES": {
            "direct": "Απευθείας - η κλήση καλείται αμέσως όταν κάνετε κλικ στον σύνδεσμο τηλεφώνου",
            "indirect": "Έμμεση - ο αριθμός τηλεφώνου προετοιμάζεται στο πεδίο εισαγωγής του widget τηλεφώνου"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Πρόσβαση σε ηχογραφήσεις κλήσεων",
          "MODES": {
            "admin_only": "Μόνο διαχειριστές",
            "admin_and_assigned_agent": "Διαχειριστές και ο ανατεθειμένος πράκτορας",
            "inbox_members": "Όλοι οι πράκτορες με πρόσβαση στο κιβώτιο εισερχομένων"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Ρυθμίσεις Email",
        "NOTE": "Τροποποιεί τη συμπεριφορά των κιβωτίων εισερχομένων email"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Λειτουργία εμφάνισης χρονοσήμανσης συνομιλίας",
        "MODES": {
          "both": "Δημιουργία και τελευταία δραστηριότητα",
          "last_activity_only": "Μόνο τελευταία δραστηριότητα",
          "last_customer_message": "Τελευταίο μήνυμα πελάτη"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Αποκλεισμός domains με χαμηλή φήμη"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Συμπερίληψη του αρχικού μηνύματος στην απάντηση του email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Αυτόματη επίλυση νέας συνομιλίας"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Αυτόματη μεταφορά νέας συνομιλίας email στα εισερχόμενα του ρομπότ που επεξεργάστηκε τις παραγγελίες της επαφής"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Εκτεταμένες ετικέτες - Επιτρέπει μεγαλύτερα ονόματα ετικετών με μεγαλύτερο αναδυόμενο περιβάλλον"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Αυτόματη ανάθεση συνομιλίας στον πράκτορα που δημιούργησε την τελευταία απάντηση"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Λειτουργία ειδοποιήσεων push",
        "MODES": {
          "all_inboxes": "Όλα τα κιβώτια εισερχομένων - Αποστολή ειδοποιήσεων για όλους τους τύπους καναλιών",
          "chat_only": "Μόνο chat - Αποστολή ειδοποιήσεων μόνο για κανάλια εκτός email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Να επιτρέπεται η εναλλαγή υπογραφής στα απεσταλμένα μηνύματα"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Εμφάνιση κατάστασης chat πράκτορα στο wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Εμφάνιση πλήρων ονομάτων συνημμένων χωρίς περικοπή"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Σύνδεση με κωδικό πρόσβασης",
        "MODES": {
          "allowed_for_all": "Επιτρέπεται για όλους τους χρήστες",
          "allowed_for_agents_only": "Επιτρέπεται μόνο για πράκτορες (οι διαχειριστές πρέπει να χρησιμοποιούν OAuth)",
          "password_login_disabled": "Απενεργοποιημένο - Μόνο OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Μια νέα έκδοση είναι διαθέσιμη. Επαναφορτώστε για να λάβετε τις τελευταίες ενημερώσεις.",
    "RELOAD_NOW": "Ενημέρωση τώρα",
    "LEARN_MORE": "Μάθετε περισσότερα",
    "PAYMENT_PENDING": "Η πληρωμή σας εκκρεμεί. Ενημερώστε τα στοιχεία πληρωμής σας για να συνεχίσετε να χρησιμοποιείτε αυτό το λογισμικό",
    "LIMITS_UPGRADE": "Ο λογαριασμός σας έχει υπερβεί τα όρια χρήσης. Αναβαθμίστε το πρόγραμμά σας για να συνεχίσετε να χρησιμοποιείτε αυτό το λογισμικό",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Πάτησε enter για επιλογή",
      "ENTER_TO_REMOVE": "Πάτησε enter για αφαίρεση",
      "NO_OPTIONS": "Η λίστα είναι κενή",
      "NO_RESULT": "Δεν βρέθηκαν αποτελέσματα",
      "SELECT_ONE": "Επιλέξτε ένα",
      "SELECT": "Επιλογή"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Ειδοποιήσεις",
    "MARK_ALL_DONE": "Όλες ολοκληρωμένες",
    "DELETE_TITLE": "διαγράφηκε",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Μη Αναγνωσμένες Ειδοποιήσεις",
      "ALL_NOTIFICATIONS": "Προβολή όλων των ειδοποιήσεων",
      "LOADING_UNREAD_MESSAGE": "Φόρτωση μη αναγνωσμένων ειδοποιήσεων...",
      "EMPTY_MESSAGE": "Δεν έχετε μη αναγνωσμένες ειδοποιήσεις"
    },
    "LIST": {
      "LOADING_MESSAGE": "Φόρτωση ειδοποιήσεων...",
      "404": "Καμία Ειδοποίηση",
      "TABLE_HEADER": [
        "Όνομα",
        "Αριθμός Τηλεφώνου",
        "Συζητήσεις",
        "Τελευταία επικοινωνία"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Νέα συνομιλία",
      "conversation_assignment": "Η Συνομιλία Ανατέθηκε",
      "assigned_conversation_new_message": "Νέο Μήνυμα",
      "participating_conversation_new_message": "Νέο Μήνυμα",
      "conversation_mention": "Αναφορά",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Εκτός",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Ανανέωση"
    },
    "CONNECTION_LOST": {
      "TITLE": "Η σύνδεση χάθηκε",
      "DESCRIPTION": "Δεν ήταν δυνατή η σύνδεση με τον διακομιστή. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.",
      "RETRY": "Δοκιμάστε ξανά"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Αναζήτηση ή μετάβαση σε",
    "SECTIONS": {
      "GENERAL": "Γενικά",
      "REPORTS": "Αναφορές",
      "CONVERSATION": "Συνομιλία",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Αλλαγή Αναδόχου",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Αλλαγή Ομάδας",
      "SNOOZE_CONVERSATION": "Αναβολή Συνομιλίας",
      "EXECUTE_MACRO": "Εκτέλεση Μακροεντολής",
      "ADD_LABEL": "Προσθήκη ετικέτας στη συνομιλία",
      "REMOVE_LABEL": "Αφαίρεση ετικέτας από την συνομιλία",
      "SETTINGS": "Ρυθμίσεις",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Μεταβείτε στον Πίνακα Συνομιλίων",
      "GO_TO_CONTACTS_DASHBOARD": "Μετάβαση στον Πίνακα Επαφών",
      "GO_TO_REPORTS_OVERVIEW": "Μετάβαση στις Αναφορές",
      "GO_TO_CONVERSATION_REPORTS": "Μετάβαση στις Αναφορές Συνομιλίας",
      "GO_TO_AGENT_REPORTS": "Μεταβείτε στις Αναφορές Πράκτορα",
      "GO_TO_LABEL_REPORTS": "Μεταβείτε στις Αναφορές Ετικετών",
      "GO_TO_INBOX_REPORTS": "Μεταβείτε στις Αναφορές Εισερχομένων",
      "GO_TO_TEAM_REPORTS": "Μεταβείτε Αναφορές Ομάδας",
      "GO_TO_SETTINGS_AGENTS": "Μεταβείτε στις Ρυθμίσεις Πράκτορα",
      "GO_TO_SETTINGS_TEAMS": "Μεταβείτε στις ρυθμίσεις ομάδας",
      "GO_TO_SETTINGS_INBOXES": "Μετάβαση στις Ρυθμίσεις Εισερχομένων",
      "GO_TO_SETTINGS_LABELS": "Μεταβείτε στις Ρυθμίσεις Ετικετών",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Μεταβείτε στις ρυθμίσεις τυποποιημένων απαντήσεων",
      "GO_TO_SETTINGS_APPLICATIONS": "Μετάβαση στις ρυθμίσεις εφαρμογής",
      "GO_TO_SETTINGS_ACCOUNT": "Μεταβείτε στις ρυθμίσεις λογαριασμού",
      "GO_TO_SETTINGS_PROFILE": "Μετάβαση στις ρυθμίσεις προφίλ",
      "GO_TO_NOTIFICATIONS": "Μετάβαση στις ειδοποιήσεις",
      "ADD_LABELS_TO_CONVERSATION": "Προσθήκη ετικέτας στη συνομιλία",
      "ASSIGN_AN_AGENT": "Εκχώρηση πράκτορα",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Εκχώρηση ομάδας",
      "EXECUTE_A_MACRO": "Εκτέλεση μακροεντολής",
      "MUTE_CONVERSATION": "Σίγαση Συνομιλίας",
      "UNMUTE_CONVERSATION": "Επαναφορά Συνομιλίας",
      "REMOVE_LABEL_FROM_CONVERSATION": "Αφαίρεση ετικέτας από την συνομιλία",
      "REOPEN_CONVERSATION": "Άνοιγμα συνομιλίας",
      "RESOLVE_CONVERSATION": "Επίλυση Συνομιλίας",
      "SEND_TRANSCRIPT": "Στείλτε μεταγραφή της συνομιλίας",
      "SNOOZE_CONVERSATION": "Αναβολή Συνομιλίας",
      "UNTIL_NEXT_REPLY": "Μέχρι την επόμενη απάντηση",
      "UNTIL_NEXT_WEEK": "Έως την επόμενη εβδομάδα",
      "UNTIL_TOMORROW": "Μέχρι αύριο",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Φόρτωση Εφαρμογής Dashboard..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "πατήστε εδώ"
  }
}
